export default __webpack_public_path__ + "static/media/KOD0010-min.314bf2e1.webp";